import React from 'react';
import TableContextContainer from '../../elements/e-commerce/Table/TableContextContainer';
import pageLogo from '../../../assets/archive-logo.svg';
import TABLE_TYPES from '../../../globalEnums/TABLE_TYPES_ENUMS';
const ArchiveProjects = () => {
  return <TableContextContainer tableType={TABLE_TYPES.FINISHED} pageTitle={'Archiwum'} logo={pageLogo} />;
};

export default ArchiveProjects;
